package pl.finn.forms.swz


import io.kvision.core.onEvent
import io.kvision.form.FormHorizontalRatio
import io.kvision.form.text.TextArea
import io.kvision.panel.FieldsetPanel
import pl.finn.forms.POLE_WYMAGANE
import pl.finn.forms.fk02.DynamicFieldsValidator


class SwzBlocks(dfv: DynamicFieldsValidator) {

    private val dynamicFieldsValidator = dfv

    val blokInformacji: (Informacje, String?) -> FieldsetPanel = { informacje, elementsName ->
        FieldsetPanel(elementsName).apply {
            add(dynamicFieldsValidator.add(
                TextArea(
                    value = informacje.informacja,
                    label = "Treść", rows = 10
                ).apply {
                    placeholder = "Podaj treść skargi, wniosku, zapytania"
                    onEvent {
                        change = {
                            informacje.informacja = self.value
                        }
                    }
                    styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)
                    flabel.addCssClass("required-label")
                },
                { elem -> ( (!elem.isNullOrEmpty() && !elem.isBlank()) || (!visible) ) },
                POLE_WYMAGANE
            ))
        }
    }


    val blokInfoDodatkowe: (InformacjeDodatkowe, String?) -> FieldsetPanel = { informacjeDodatkowe, elementsName ->
        FieldsetPanel(elementsName).apply {
            add(

                TextArea(
                    value = informacjeDodatkowe.informacjaDodatkowa,
                    label = "Informacje dodatkowe",
                    rows = 10
                ).apply {
                    placeholder = "Podaj treść informacji"
                    onEvent {
                        change = {
                            informacjeDodatkowe.informacjaDodatkowa = self.value
                        }
                    }
                    styleForHorizontalFormPanel(FormHorizontalRatio.RATIO_3)

                }
            )
        }
    }

}